import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { IAPIData } from '@shared/interfaces/api.interface';
import { LeadTypeNotification as ILeadTypeNotification } from '@shared/interfaces/setting.interface';
import { LeadTypeNotification } from '@shared/models/lead-type-notification.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LeadTypeNotificationsService {
  private readonly ENDPOINT_V3: string = String(
    `${environment.ENDPOINTS.BACK_END.V3}/lead_types`
  );

  constructor(private readonly _http: HttpClient) {}

  public get(leadTypeId: string): Observable<ILeadTypeNotification> {
    return this._http
      .get<IAPIData>(`${this.ENDPOINT_V3}/${leadTypeId}/notification`)
      .pipe(map((res: IAPIData) => LeadTypeNotification.fromAPI(res)));
  }

  public update(leadTypeId: string, body: IAPIData): Observable<ILeadTypeNotification> {
    return this._http
      .patch<IAPIData>(`${this.ENDPOINT_V3}/${leadTypeId}/notification`, body)
      .pipe(map((res: IAPIData) => LeadTypeNotification.fromAPI(res)));
  }
}
